import type { ChatterStatus } from '@/api/resources/chatters/model'
import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'

export class GetNudgedChatters extends Performer<
  {
    payload: {
      chatterId: number
      outcome: { id: number } | string
      stage: ChatterStatus
      comment?: string
    }
  },
  void
> {
  protected method = HttpMethod.POST
  protected url = '/nudge/add'
}

export default new GetNudgedChatters().perform
